class CarouselPermissions {
    constructor({ show = false } = {}) {
        this.show = show
    }
}

export default CarouselPermissions
